define('pages/main/order',["jquery", "appquery", "app", 'modules/order'], function($, $$, App, Order) {
    $$ = $$("order");
    var source;

    function throwError(message) {
        $$('#searchForm').append('<div id="errorMessage" class="text-left"><label class="text-danger">' + message + '</label></div>');
    }

    return {
        init : function(data) {
            var searchBox = $$('#searchbox');
            var searchForm = $$('#searchForm');
            var source = App.global('map_source').split(',').map(Number);

            searchForm.submit(function(e) {
                e.preventDefault();
                var reference_number = searchBox.val();

                $$('#errorMessage').remove();
                var button = App.button(this).load();
                App.api.call('/order.getDetails', {
                    'store_id': App.global('store'),
                    'reference_number' : reference_number
                }, function(response) {
                    App.page.render('spinner', 'Please wait while we are calculating shortest path for order...', true);
                    Order.getPathForOrder(response, source, function(message){
                        App.page.back();
                        throwError(message);
                    });
                }, throwError, function() {
                    App.page.render('order', {reference_number : reference_number});
                }).always(function() {
                    button.reset();
                });
            });

            if(data.reference_number) {
                searchBox.val(data.reference_number);
                searchForm.submit();
                data.reference_number = null;
            }
        },
        footer : true
    };
});
